export default __webpack_public_path__ + "5edc32360bcc07e165069a432c37a94c.png";